import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19.14 12a7.14 7.14 0 0 0-2.919-5.756l-.557-3.07A1.43 1.43 0 0 0 14.26 2H9.737a1.43 1.43 0 0 0-1.405 1.174l-.557 3.07a7.134 7.134 0 0 0 0 11.512l.557 3.07A1.43 1.43 0 0 0 9.737 22h4.522a1.43 1.43 0 0 0 1.405-1.174l.557-3.07A7.14 7.14 0 0 0 19.141 12M9.738 3.429h4.522l.349 1.924a7.12 7.12 0 0 0-5.22 0zM6.284 12a5.714 5.714 0 1 1 5.714 5.714A5.72 5.72 0 0 1 6.284 12m7.975 8.571H9.737l-.349-1.924a7.12 7.12 0 0 0 5.22 0zM11.284 12V8.429a.714.714 0 1 1 1.428 0v2.857h2.858a.714.714 0 0 1 0 1.428h-3.572a.714.714 0 0 1-.714-.714"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }